import { Link, useNavigate } from "react-router-dom";
import { contextApi } from "../../context/contextApi";
import { useContext } from "react";

const DEFAULT_ICON = "/images/wallet-curency.png";

export const BoxCard = (props) => {
  const navigate = useNavigate();
  const context = useContext(contextApi);

  const handleSetSession = () => {
    localStorage.course = props.title;
  };

  const handleClick = (buttonName) => {
    context.recordClick(buttonName);
  };

  const iconSrc = props.item?.icon || DEFAULT_ICON;
  const iban = props.item?.pivot?.internal_iban;

  return (
    <div
      className={`box-card pb-3 min-w-0 h-full flex flex-col ${
        props.isDark ? "card" : "card2"
      }`}
    >
      <div className="p-4 flex-1">
        <div className="flex flex-col items-center text-center mb-4">
          <div className="w-16 h-16 rounded-full flex items-center justify-center bg-[#0010c6]/10 dark:bg-white/10 mb-3">
            <img
              src={iconSrc}
              alt={props.title}
              className={`w-9 h-9 object-contain brightness-0 saturate-100 ${
                props.isDark ? "invert" : ""
              }`}
            />
          </div>
          <h3
            className={`text-lg font-bold ${
              props.isDark ? "text-white" : "text-[#0010c6]"
            }`}
          >
            {props.title}
          </h3>
        </div>

        <div
          className={`flex flex-row justify-between items-center mb-2 pb-2 border-b ${
            props.isDark ? "border-white/10" : "border-[#0010c6]/10"
          }`}
        >
          <p
            className={`text-sm ${
              props.isDark ? "text-white" : "text-[#0010c6]"
            }`}
          >
            موجودی کل
          </p>
          <p className="text-lg font-bold text-success font-vazir-num">
            {new Intl.NumberFormat("fa-IR").format(props.item.pivot.amount)}
          </p>
        </div>

        <div
          className={`flex flex-row justify-between items-center mb-2 pb-2 border-b ${
            props.isDark ? "border-white/10" : "border-[#0010c6]/10"
          }`}
        >
          <p
            className={`text-sm ${
              props.isDark ? "text-white" : "text-[#0010c6]"
            }`}
          >
            غیرقابل برداشت
          </p>
          <span className="font-vazir-num font-semibold text-sm text-error">
            {new Intl.NumberFormat("fa-IR").format(
              props.item.pivot.non_withdrawal
            )}
          </span>
        </div>

        <div
          className={`flex flex-row justify-between items-center mb-2 pb-2 border-b ${
            props.isDark ? "border-white/10" : "border-[#0010c6]/10"
          } ${iban ? "" : "invisible"}`}
        >
          <p
            className={`text-sm ${
              props.isDark ? "text-white" : "text-[#0010c6]"
            }`}
          >
            شماره شبا
          </p>
          <p
            className={`text-sm font-semibold font-vazir-num ${
              props.isDark ? "text-white" : "text-[#0010c6]"
            }`}
            dir="ltr"
          >
            {iban || "-"}
          </p>
        </div>

        <div className="spinner mt-4">
          <div className="loading"></div>
        </div>
      </div>
      <div className="flex flex-row px-4 justify-around gap-2 text-xs">
        <div className="basis-full text-xs md:text-md">
          <button
            type="button"
            className={`btn-danger border border-solid  py-3 box-link w-full rounded-lg flex flex-col items-center justify-center transition-all duration-300 hover:scale-105 ${
              props.isDark
                ? "text-white border-white hover:bg-white/10"
                : "text-[#0010c6] hover:bg-[#0010c6]/10"
            }`}
            onClick={() => {
              handleClick(` برداشت در${props.pageName} `);
              navigate(`/ReciveMoney?id=${props.id}&itemId=${props.itemId}`, {
                state: {
                  amount: props.item.pivot.amount,
                  title: props.title,
                },
              });
            }}
          >
            {props.isDark ? (
              <img
                src="/images/dollar.png"
                alt=""
                className="mb-2"
                width={25}
              />
            ) : (
              <img src="/images/money.png" alt="" className="mb-2" width={25} />
            )}

            <p className="font-medium">برداشت</p>
          </button>
        </div>
        <div className="basis-full text-xs md:text-md">
          <Link to={`/Bill?id=${props.id}`}>
            <button
              type="button"
              className={`btn-success  border border-solid py-3 box-link w-full rounded-lg flex flex-col items-center justify-center transition-all duration-300 hover:scale-105 ${
                props.isDark
                  ? "text-white border-white hover:bg-white/10"
                  : "text-[#0010c6] border-[#0010c6] hover:bg-[#0010c6]/10"
              }`}
              onClick={() => handleClick(` گزارشات در${props.pageName} `)}
            >
              <img
                src="/images/reports.png"
                alt=""
                className="mb-2"
                width={25}
              />
              <p className="font-medium">گزارشات</p>
            </button>
          </Link>
        </div>
        <div className="basis-full text-xs md:text-md">
          <Link to={`convert?id=${props.id}`} onClick={handleSetSession}>
            <button
              type="button"
              className={` border border-solid btn-secondary py-3 box-link w-full rounded-lg flex flex-col items-center justify-center transition-all duration-300 hover:scale-105 ${
                props.isDark
                  ? "text-white border-white hover:bg-white/10"
                  : "text-[#0010c6] border-[#0010c6] hover:bg-[#0010c6]/10"
              }`}
              onClick={() => {
                handleClick(` تبدیل در${props.pageName} `);
              }}
            >
              <img
                src="/images/convert.png"
                alt=""
                className="mb-2"
                width={25}
              />
              <p className="font-medium">تبدیل</p>
            </button>
          </Link>
        </div>
      </div>
    </div>
  );
};
